import stanley from './neighborhoods/stanley.json';
import mansheya from './neighborhoods/mansheya.json';
import montaza from './neighborhoods/montaza.json';
import anfoushi from './neighborhoods/anfoushi.json';
import gleem from './neighborhoods/gleem.json';
import sidiBishr from './neighborhoods/sidi-bishr.json';
import smouha from './neighborhoods/smouha.json';
import sidiGaber from './neighborhoods/sidi-gaber.json';
import roushdy from './neighborhoods/roushdy.json';
import sanStefano from './neighborhoods/san-stefano.json';

export const NEIGHBORHOODS = [
stanley,
mansheya,
montaza,
anfoushi,
gleem,
sidiBishr,
smouha,
sidiGaber,
roushdy,
sanStefano];